import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  /**
   * GET `/alert/incident` — riwayat insiden alert. SUDAH di-unwrap: yang balik
   * `response.data` (body), jadi jalur bacanya `body.data`.
   *
   * `status.errorCode` datang dengan HTTP 200, jadi adanya `status` di body udah
   * berarti gagal — pemanggil nge-throw pakai `status.message`
   * (src/views/alert/AlertHistory.vue:284).
   *
   * Query dirakit MANUAL jadi string, bukan lewat `params` axios, karena axios gak bisa
   * ngebentuk `finds[k][]`. Konvensinya sama persis sama EventLogSvc: `finds[k]=v` buat
   * nilai tunggal, `finds[k][]=v` diulang buat array, `orders[k]=ASC|DESC`, sisanya key
   * polos. Nilai kosong, null, dan undefined dibuang, dan nilainya TIDAK di-encode.
   *
   * Beda dari EventLogSvc: yang ini nangkep error axios, nyatet ke console, lalu
   * nge-throw ulang — jadi kegagalan jaringan tetep sampai ke pemanggil.
   *
   * @param {Object} [options]
   * @param {Object.<string, string|number|Array>} [options.finds] filter per kolom
   * @param {Object.<string, string>} [options.orders] urutan per kolom
   * @param {Object} [options.params] param polos, mis. `max`
   * @returns {Promise<{data: Object[], status: import('@/services/_AxiosInstance').ApiStatus}>}
   *   body sudah di-unwrap
   * @throws {Error} error axios apa adanya kalau requestnya gagal
   */
  getIncidents: async (options = {}) => {
    const {
      finds = {},
      orders = {},
      params = {},
    } = options;

    const findsParts = [];
    Object.entries(finds).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) return;
      if (Array.isArray(value)) {
        value.forEach((v) => findsParts.push(`finds[${key}][]=${v}`));
      } else {
        findsParts.push(`finds[${key}]=${value}`);
      }
    });

    const ordersParts = [];
    Object.entries(orders).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) return;
      ordersParts.push(`orders[${key}]=${value}`);
    });

    const otherParts = [];
    Object.entries(params).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) return;
      otherParts.push(`${key}=${value}`);
    });

    const queryString = [...findsParts, ...ordersParts, ...otherParts].join('&');

    try {
      const response = await axiosInstance.get(`/alert/incident?${queryString}`, {
        cancelToken: getNewCancelToken(),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching alert incidents:', error);
      throw error;
    }
  },
};
